// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2L2aA","filesListContainer":"PosDisputesFiles_filesListContainer__nsViw","filesButton":"PosDisputesFiles_filesButton__1nI9L"};